import { createSelector } from 'reselect';

const getExercises = (state) => state.exercise.entities;
const getHomeworkId = (state, homeworkId) => homeworkId;
const getHomework = (state) => state.homework.entities;
const getTreatment = (state) => state.treatment.entities;
const getUser = (state) => state.authentication.user;

export const getExercisesByHomework = createSelector(
    [getExercises, getHomeworkId, getHomework, getTreatment, getUser],
    (exercises, homeworkId, homework, treatment, user) => {
        const selectedHomework = homework.byId[homeworkId];
        const userTreatments = user.treatments;

        // because treatments can now be attached multiple times, we need to find the one that is open
        const selectedTreatment = userTreatments.find(
            (treatment) =>
                treatment.id === selectedHomework.treatment_id &&
                treatment.pivot.open === 1
        );
        const { level } = selectedTreatment.pivot;

        if (!selectedHomework.exercises) {
            return [];
        }

        let allExercises = selectedHomework.exercises.map(
            (exerciseId) => exercises.byId[exerciseId]
        );
        allExercises = allExercises.filter(
            (exercise) =>
                exercise &&
                (exercise.level === level || exercise.level === 'no_level')
        ); // only show levels that were assigned to user

        return allExercises;
    }
);
